module.exports = __webpack_public_path__ + "static/media/wing-right.114b77c4.svg";